const ROOT_PATH = '/price-lists';

export const PriceListsPaths = {
  ROOT_PATH,
} as const;
